document.addEventListener('DOMContentLoaded', function () {

  /* --------------------------------------------------------------------------
    OPEN MODAL
  -------------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-trigger-modal]');
    if (!trigger) return;

    const modalId = trigger.getAttribute('data-modal-trigger-id');
    if (!modalId) return;

    const modal = document.querySelector(`.modal[data-modal-id="${modalId}"]`);
    if (!modal) return;

    const overlay = modal.nextElementSibling?.classList.contains('modal__Overlay')
      ? modal.nextElementSibling
      : null;

    modal.classList.add('modal--is-active');

    if (overlay) {
      overlay.classList.add('modal__Overlay--is-active');
    } else {
      console.warn('⚠️ Overlay not found as adjacent sibling to modal');
    }

    /* --------------------------------------------------
      DISPATCH OPEN EVENT
    -------------------------------------------------- */
    window.dispatchEvent(
      new CustomEvent('modal:opened', {
        detail: {
          modal,
          modalId,
          trigger
        }
      })
    );
  });

  /* --------------------------------------------------------------------------
    CLOSE MODAL
  -------------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    const closeTrigger = event.target.closest('[data-modal-close]');
    if (!closeTrigger) return;

    const activeModal = document.querySelector('.modal.modal--is-active');
    if (!activeModal) return;

    const modalId = activeModal.getAttribute('data-modal-id');

    const overlay = activeModal.nextElementSibling?.classList.contains('modal__Overlay')
      ? activeModal.nextElementSibling
      : null;

    activeModal.classList.remove('modal--is-active');

    if (overlay) {
      overlay.classList.remove('modal__Overlay--is-active');
    }

    /* --------------------------------------------------
      DISPATCH CLOSE EVENT
    -------------------------------------------------- */
    window.dispatchEvent(
      new CustomEvent('modal:closed', {
        detail: {
          modal: activeModal,
          modalId
        }
      })
    );
  });

  window.addEventListener('modal:opened', (event) => {
    const { modal } = event.detail;

    setTimeout(() => {
      if (!modal.classList.contains('modal--is-active')) return;

      // HTML5 videos
      modal.querySelectorAll('video').forEach(video => {
        video.currentTime = 0;
        video.play().catch(() => {
          // autoplay may be blocked
        });
      });

      // YouTube / Vimeo iframes
      modal.querySelectorAll('iframe').forEach(iframe => {
        const src = iframe.getAttribute('src');
        if (!src) return;

        if (!src.includes('autoplay=1')) {
          const separator = src.includes('?') ? '&' : '?';
          iframe.dataset.modalOriginalSrc = src;
          iframe.setAttribute('src', `${src}${separator}autoplay=1`);
        }
      });
    }, 500);
  });

  window.addEventListener('modal:closed', (event) => {
    const { modal } = event.detail;

    if (!modal) return;

    modal.querySelectorAll('video').forEach(video => {
      video.pause();
      video.currentTime = 0;
    });

    modal.querySelectorAll('iframe').forEach(iframe => {
      const src = iframe.getAttribute('src');
      const originalSrc = iframe.dataset.modalOriginalSrc || src;

      if (originalSrc) {
        iframe.setAttribute('src', originalSrc);
        delete iframe.dataset.modalOriginalSrc;
      }
    });
  });

});
